import React from 'react';

interface SwapIconProps {
    className?: string;
}

const SwapIcon: React.FC<SwapIconProps> = ({ className = "w-4 h-4" }) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className}>
        <polyline points="7 7 11 3 7 7 11 3"></polyline>
        <line x1="11" y1="3" x2="11" y2="21"></line>
        <polyline points="13 21 17 17 13 21 17 17"></polyline>
    </svg>
);

export default SwapIcon;
